import { Component, OnInit } from "@angular/core";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import {
  slidersHorizontal,
  VAIconRegistryService,
} from "@va/core-library/icons";
import { SectorIndustry } from "src/app/store/models/industry-page.model";
import { Dictionary } from "src/app/store/models/common_types";
import {
  SetIndustryMengMenuVisibility,
  ResetSectorIndustryData,
} from "src/app/store/actions/sector-industry.actions";
@Component({
  selector: "app-industry-subheader",
  templateUrl: "./industry-subheader.component.html",
  styleUrls: ["./industry-subheader.component.scss"],
})
export class IndustrySubheaderComponent implements OnInit {
  ALL_ITEMS_ID = -1;
  ALL_COMPANIES_TEXT = "All Companies in Industry";
  MULTIPLE_GEOGRAPHIES_TEXT = "Multiple Geographies";
  MULTIPLE_MARKET_CAP_TEXT = "Multiple Market Cap";
  ALL_MARKET_CAP_TEXT = "All Market Cap";
  ALL_GEOGRAPHIES_TEXT = "All Geographies";
  selectedSector = "";
  selectedIndustry = "";
  selectedIndustryId: string;
  isMegaMenuVisible = false;
  isMegaMenuVisibleStoreValue = false;
  selectedCluster: Array<Dictionary<any> | number>;
  selectedMarketCaps: Array<number>;
  geographies: Dictionary<any>;
  selectedClusterText = "";
  selectedGeographyText = "";
  selectedMarketCapText = "";
  selectedCompanyCount: number;
  sectorIndustryStoreSubscriber: Subscription;
  constructor(
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([slidersHorizontal]);
  }

  ngOnInit() {
    this.sectorIndustryStoreSubscriber = this.store
      .select(stateGetter("sectorIndustry"))
      .subscribe((_sectorIndustryState: SectorIndustry) => {
        if (_sectorIndustryState.hasData) {
          this.selectedSector = _sectorIndustryState.selectedSectorName;
          this.selectedIndustry = _sectorIndustryState.selectedIndustryName;
          this.selectedIndustryId = _sectorIndustryState.selectedIndustryId;
          if (_sectorIndustryState.hasSubHeaderData) {
            this.selectedCluster = _sectorIndustryState.subHeaderData.subGroups;
            this.selectedMarketCaps =
              _sectorIndustryState.subHeaderData.marketCaps;
            this.geographies = _sectorIndustryState.subHeaderData.geographies;
            this.selectedClusterText = this.getSelectedClusterText();
            this.selectedGeographyText = this.getGeographyText();
            this.selectedMarketCapText = this.getMarketCapText();
          }
        }
        this.isMegaMenuVisibleStoreValue =
          _sectorIndustryState.isIndustryMegaMenuVisible;
        this.isMegaMenuVisible = _sectorIndustryState.isIndustryMegaMenuVisible;
      });
  }

  ngOnDestroy() {
    this.store.dispatch(
      new ResetSectorIndustryData({
        reset: true,
      }),
    );
    if (this.sectorIndustryStoreSubscriber) {
      this.sectorIndustryStoreSubscriber.unsubscribe();
    }
  }
  getMarketCapText() {
    let text = "";
    if (this.selectedMarketCaps && this.selectedMarketCaps.length === 0) {
      text = this.ALL_MARKET_CAP_TEXT;
    } else if (
      this.selectedMarketCaps &&
      this.selectedMarketCaps[0] === this.ALL_ITEMS_ID
    ) {
      text = this.ALL_MARKET_CAP_TEXT;
    } else {
      const values =
        (this.selectedMarketCaps &&
          this.selectedMarketCaps.length &&
          Object.values(this.selectedMarketCaps[0])) ||
        [];
      if (values && values.length === 1) {
        text = values[0];
      } else if (values && values.length > 1) {
        text = this.MULTIPLE_MARKET_CAP_TEXT;
      }
    }

    return text;
  }

  getGeographyText() {
    let text = "";
    const regions = (this.geographies && this.geographies.regions) || [];
    const countries = (this.geographies && this.geographies.countries) || [];

    if (regions.length + countries.length === 0) {
      text = this.ALL_GEOGRAPHIES_TEXT;
    } else if (regions[0] === this.ALL_ITEMS_ID) {
      text = this.ALL_GEOGRAPHIES_TEXT;
    } else {
      const selectedRegions: Array<string> =
        (regions && regions[0] && Object.values(regions[0])) || [];
      const selectedCountries: Array<string> =
        (countries && countries[0] && Object.values(countries[0])) || [];
      const selectedItems: Array<string> = [
        ...selectedCountries,
        ...selectedRegions,
      ];
      if (selectedItems.length === 1) {
        text = selectedItems[0];
      } else if (selectedItems.length > 1) {
        text = this.MULTIPLE_GEOGRAPHIES_TEXT;
      }
    }
    return text;
  }
  getSelectedClusterText() {
    if (this.selectedCluster && this.selectedCluster.length === 0) {
      return this.ALL_COMPANIES_TEXT;
    }
    if (this.selectedCluster && this.selectedCluster[0] === this.ALL_ITEMS_ID) {
      return this.ALL_COMPANIES_TEXT;
    }
    if (this.selectedCluster && this.selectedCluster.length) {
      return Object.values(this.selectedCluster[0])[0];
    }
    return "";
  }

  setIndustryMegaMenuVisibility(value) {
    if (this.store) {
      this.store.dispatch(
        new SetIndustryMengMenuVisibility({
          isIndustryMegaMenuVisible: value,
        }),
      );
    }
  }

  /**
   * Executes when user click on Cancel/Apply button
   * It closes the mega menu
   */
  onClose() {
    this.setIndustryMegaMenuVisibility(false);
  }

  /**
   * Executes whenever visibility of megamenu changes
   * Here we are updating the visibility state of mega menu in store
   * When user clicks outside of the popup instead of using close/apply button, we need to update that state to store
   */
  handlePopoverVisibilityChange(value) {
    if (this.isMegaMenuVisibleStoreValue !== value) {
      this.setIndustryMegaMenuVisibility(value);
    }
  }
}
